import React, { useState, useContext } from "react";
import {  one, three, four, two, five , six } from "../../../assets/images";
import CustomButton from "../../../shared/custom-button/custom-button";
import { SnackbarContext } from "../../../config/hooks/use-toast";
interface ContentItem {
  id: string;
  label: string;
  content: Array<{
    title: string;
    description: string;
    image?: string; 
  }>;
}

const contents: ContentItem[] = [
  {
    "id": "primaire",
    "label": "Primaire",
    "content": [
      {
        title: "Matières Primaire - Année 1",
        "description": "Première année, centrée sur les compétences de base en lecture et en mathématiques.",
        image: one
      },
      {
        title: "Matières primaire - Année 2",
        description: "Deuxième année, développement de la lecture, de l'écriture et des premières notions de sciences.",
        image: two
      },
      {
        title: "Matières Primaire - Année 3",
        description: "Troisième année, approfondissement de l'histoire, des langues et de la pensée critique.",
        image: three
      },
      {
        title: "Matières Primaire - Année 4",
        description: "Quatrième année, perfectionnement des compétences et introduction à des sujets plus complexes.",
        image: four
      },
      {
        title: "Matières Primaire - Année 5",
        description: "Cinquième année, préparation à la transition vers le collège avec des matières plus avancées.",
        image: five
      },
      {
        title: "Matières Primaire - Année 6",
        description: "Sixième année, préparation aux examens finaux et révision des matières essentielles.",
        image: six
      }
    ]
  },
  {
    "id": "college",
    "label": "Collège",
    "content": [
      {
        title: "Cours Collège - Année 1",
        description: "Septième année, 'Première', introduction aux matières principales et à la pensée critique.",
        image : one
      },
      {
        title: "Cours Collège - Année 2",
        description: "Huitième année, 'Deuxième', approfondissement des connaissances en sciences, langues et mathématiques.",
        image: two
      },
      {
        title: "Cours Collège - Année 3",
        description: "Neuvième année, 'Troisième', préparation à la transition vers le lycée avec des sujets plus complexes.",
        image: three
      }
    ]
  },
  {
    "id": "lycee",
    "label": "Lycée",
    "content": [
      {
        title: "Curriculum Lycée - Année 1",
        description: "Première année secondaire, 'Première', introduction aux matières spécialisées et aux choix de parcours.",
        image: one
      },
      {
        title: "Curriculum Lycée - Année 2",
        description: "Deuxième année secondaire, 'Deuxième', approfondissement des connaissances et développement des compétences analytiques.",
        image : two
      },
      {
        title: "Curriculum Lycée - Année 3",
        description: "Troisième année secondaire, 'Troisième', préparation aux examens finaux et révision des matières essentielles.",
        image: three
      },
      {
        title: "Curriculum Lycée - Année 4",
        description: "Quatrième année secondaire, 'Baccalauréat', ultime préparation pour les examens de fin d'études et la transition vers l'université.",
        image: four
      }
    ]
  }
  ,
];

const Classes = () => {
  const [activeTab, setActiveTab] = useState<string>(contents[0].id);
  const snackBar = useContext(SnackbarContext);

  const renderContent = () => {
    const activeContent = contents.find(
      (item) => item.id === activeTab,
    )?.content;

    return (
      <div
        id="free-courses"
        className="flex flex-wrap justify-center gap-8 px-6 md:px-12 max-w-7xl mx-auto mt-12"
      >
        {activeContent?.map((item, index) => (
          <div
            key={index}
            className="group relative bg-white rounded-3xl p-8 border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-2 flex flex-col items-center text-center h-full w-full sm:w-[calc(50%-2rem)] md:w-[calc(33.333%-2rem)] lg:w-[calc(25%-2rem)] min-w-[280px]"
          >
            <div className="w-20 h-20 bg-primary/5 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500">
              {item.image && (
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-12 h-12 object-cover"
                />
              )}
            </div>
            <h3 className="text-xl font-bold text-title mb-4 leading-tight min-h-[3rem] flex items-center justify-center">
              {item.title}
            </h3>
            <p className="text-text text-sm leading-relaxed mb-8 flex-grow">
              {item.description}
            </p>
            <button
              onClick={() => snackBar?.showMessage("Détails du cours", "Veuillez vous authentifier pour accéder aux détails du cours.", "info")}
              className="mt-auto w-full py-3 px-4 rounded-xl border border-primary/20 text-primary font-bold text-sm tracking-wide transition-all duration-300 hover:bg-primary hover:text-white hover:border-primary active:scale-95"
            >
              Détails du cours
            </button>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="py-24 bg-[#fcfcfc] relative overflow-hidden">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-primary/5 blur-[120px] rounded-full -translate-y-1/2 translate-x-1/2"></div>
      
      <div className="max-w-4xl mx-auto px-6 text-center mb-16 relative z-10">
        <div className="inline-block px-4 py-1 bg-primary/10 text-primary rounded-full text-sm font-bold mb-6">
          Découvrez nos programmes
        </div>
        <h2 className="text-4xl md:text-5xl font-black text-title mb-6 tracking-tight">
          Cours qualifiés pour <span className="text-primary italic">chaque niveau</span>
        </h2>
        <p className="text-lg text-text max-w-2xl mx-auto leading-relaxed">
          Accédez à une éducation de qualité adaptée à votre parcours scolaire.
          Choisissez votre niveau pour explorer des cours structurés et stimulants.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-4 px-6 mb-12 relative z-10">
        {contents.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`px-8 py-3 rounded-full font-bold text-sm transition-all duration-300 ${
              activeTab === item.id
                ? "bg-primary text-white shadow-lg shadow-primary/30 scale-105"
                : "bg-white text-title border border-gray-100 hover:border-primary/30 hover:shadow-md"
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="relative z-10 min-h-[400px]">
        {renderContent()}
      </div>

      <div className="mt-20 text-center relative z-10">
        <CustomButton 
          text="Explorer tous les cours" 
          onClick={() => snackBar?.showMessage("Détails du cours", "Veuillez vous authentifier pour accéder aux détails du cours.", "info")}
          className="h-14 px-10 text-base font-bold shadow-xl shadow-primary/20"
        />
      </div>
    </div>
  );
};

export default Classes;
